
    import { Options, Vue } from "vue-class-component";
    import CardRh from "@/components/cards/ManzaCard.vue";
    import NotaService from "@/service/v10/sigap/NotaService";
    import KDataTable from "@/components/datatable/newdatatable.vue";
    import SiteUtils from '@/assets/ts/aplicacao/site';
    import $ from "jquery";

    @Options({
        name: "NotasIndex",
        components: { CardRh, KDataTable },
    })
    export default class NotasIndex extends Vue {
        public processando = false;
        public reloadDatatable = false;
        public config: any = null;
        public service: any = null;
        public matriculaId: any = null;
        public notaMin = '';
        public notaMax = '';

        public refreshTable() {
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable;
            }, 300);
        }

        public apertouEnter(e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                this.refreshTable();
            }
        }
 

        created() {
            this.matriculaId = this.$route.params.id;
            this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
            this.service = new NotaService();
            this.config.ajax = {
                url: this.service.getApiUrl(),
                data: (d) => {
                    const dados = {
                        Skip: d.start,
                        Take: d.length,
                        matriculaId: this.matriculaId,
                        notaMax: this.notaMax,
                        notaMin: this.notaMin,
                        search: d.search.value,
                    };
                    return dados;
                }
            };

            this.config.columns = [
                { data: 'disciplina.descricao', name: 'disciplina' },
                { data: 'tipo', name: 'tipo' },
                { data: 'notaValor', name: 'notavalor' },
                { data: 'status', name: 'status ' },
                { data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center all' }
            ];

            this.config.columnDefs = [
                {
                    targets: 1,
                    render: (row) => {
                        return row.nome.replaceAll('_', ' ');
                    }
                },
                {
                    targets: 3,
                    render: (row) => {
                        return row.nome.replaceAll('_', ' ');
                    }
                },
                {
                    targets: 4,
                    render: (row, type, val) => {
                        let texto = '';
                        if (val.status.id == 2) {
                            const buttom = ' data-id="' + val.id + '"';
                            texto = texto + '<button class="btn btn-warning btn-sm" btn-revisao ' + buttom + '><i class="fa-solid fa-magnifying-glass"></i>Solicitar revisao</button>';
                            texto = texto + '<button class="btn btn-success btn-sm" btn-homologar ' + buttom + '><i class="fa fa-medal"></i>Homologar</button>';
                        }
                        return texto;
                    },
                }
            ];
        }

        public tableatualizada() {
            $('[btn-revisao]').click((btn) => {
                const nota_id = $(btn.currentTarget).data('id');
                this.solicitarRevisao(nota_id);
            });
            $('[btn-homologar]').click((btn) => {
                const nota_id = $(btn.currentTarget).data('id');
                this.homologarNota(nota_id);
            });
        }

        protected solicitarRevisao(id) {
            SiteUtils.alertConfimacao('Deseja solicitar a revisao da nota? ', '',
                () => {
                    this.processando = true;
                    setTimeout(() => {
                        this.service.solicitarRevisaoProfile(id)
                            .then(() => {
                                this.reloadDatatable = !this.reloadDatatable;
                                SiteUtils.alertNotificacao('ATENCAO!', 'Sua nota foi devolvida para analise! Crie um CHAMADO explicando o motivo da solicitacao de revisao!');
                                this.processando = false;
                            })
                            .catch(error => {
                                this.processando = false;
                                SiteUtils.toastErro('Nao foi possivel solicitar Revisao', error.data.message);
                            });
                    }, 10);
                }
            );
        }

        protected homologarNota(id) {
            SiteUtils.alertConfimacao('Deseja dar o ciente a nota? ', '(Apos esta acao a nota sera arquivada)',
                () => {
                    this.processando = true;
                    setTimeout(() => {
                        this.service.homologarNotaProfile(id)
                            .then(() => {
                                this.reloadDatatable = !this.reloadDatatable;
                                SiteUtils.toastSucesso('Ciente cadastrado com successo.');
                                this.processando = false;
                            })
                            .catch(error => {
                                this.processando = false;
                                SiteUtils.toastErro('Nao foi possivel dar o ciente na Nota', error.data.message);
                            });
                    }, 10);
                }
            );
        }
    }
